// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2xnBE","col":"styles_col__1qYFQ","fulfillmentStatus":"styles_fulfillmentStatus__2AxI8","emailCol":"styles_emailCol__eAtfE"};